import { useState } from 'react';
import { useReabrirRateio } from '@/api/rateios';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';
import { Input } from '@/components/ui/input';
import { mensagemApi } from './comum';

const PALAVRA = 'REABRIR';

interface Props {
  competencia: string;
  aberto: boolean;
  onFechar: () => void;
  /** Chamado depois que a API reabriu o rateio (a tela pode recarregar o que depende dele). */
  onReaberto?: () => void;
}

/** Confirmacao para reabrir o rateio fechado: so libera o botao ao digitar REABRIR. */
export function ReabrirRateioDialog({ competencia, aberto, onFechar, onReaberto }: Props) {
  const reabrir = useReabrirRateio();
  const [digitado, setDigitado] = useState('');
  const [erro, setErro] = useState<string | null>(null);

  const fechar = () => {
    setDigitado('');
    setErro(null);
    onFechar();
  };

  return (
    <AlertDialog open={aberto} onOpenChange={(o) => !o && !reabrir.isPending && fechar()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Reabrir o rateio de {competencia}?</AlertDialogTitle>
          <AlertDialogDescription>
            As CIFs do mês voltam a ser editáveis e o custo por minuto gravado pelo rateio é apagado. O rateio atual fica guardado na auditoria. Orçamentos e versões já aprovados mantêm o custo que tinham.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex flex-col gap-1.5">
          <label htmlFor="reabrir-rateio-confirmacao" className="text-small font-medium text-ink-secondary">
            Para confirmar, digite {PALAVRA}
          </label>
          <Input id="reabrir-rateio-confirmacao" value={digitado} onChange={(e) => setDigitado(e.target.value)} autoComplete="off" disabled={reabrir.isPending} />
        </div>
        {erro && (
          <p role="alert" className="text-small text-danger-ink">
            Não foi possível reabrir o rateio: {erro}
          </p>
        )}
        <AlertDialogFooter>
          <AlertDialogCancel disabled={reabrir.isPending}>Voltar</AlertDialogCancel>
          <AlertDialogAction
            disabled={digitado !== PALAVRA || reabrir.isPending}
            onClick={(e) => {
              e.preventDefault(); // o dialogo fecha so quando a reabertura der certo; erro mantem aberto
              setErro(null);
              reabrir.mutate(
                { competencia },
                {
                  onSuccess: () => {
                    fechar();
                    onReaberto?.();
                  },
                  onError: (err) => setErro(mensagemApi(err)),
                },
              );
            }}
          >
            {reabrir.isPending ? 'Reabrindo…' : 'Reabrir rateio'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
